var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C154.506 0 66.8103 59.065 25.4023 144.696H486.597C445.19 59.065 357.493 0 256 0V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 512C154.506 512 66.8103 452.935 25.4023 367.304H486.597C445.19 452.935 357.493 512 256 512V512Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.911 178.087H12.089C4.247 202.656 0 228.831 0 256C0 283.169 4.247 309.344 12.089 333.913H499.91C507.753 309.344 512 283.169 512 256C512 228.831 507.753 202.656 499.911 178.087Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.715 118.301L305.398 104.308L256 216.159L206.602 104.308L176.285 118.301L237.613 256L176.285 393.699L206.602 407.692L256 295.841L305.398 407.692L335.715 393.699L274.387 256L335.715 118.301Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.591 131.489C264.855 118.672 256 111.304 256 111.304C256 111.304 247.145 118.671 235.409 131.489V380.509C247.145 393.328 256 400.696 256 400.696C256 400.696 264.855 393.329 276.591 380.51V131.489Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.348 179.243V332.755C212.75 354.73 227.929 372.742 239.305 384.684V127.315C227.929 139.256 212.749 157.269 200.348 179.243V179.243Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.651 179.243C299.248 157.268 284.07 139.256 272.694 127.315V384.684C284.069 372.742 299.248 354.73 311.651 332.755V179.243Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.652 179.243V332.755C324.207 310.506 333.913 284.197 333.913 256C333.913 227.803 324.207 201.493 311.652 179.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.348 179.243V332.755C187.793 310.506 178.087 284.197 178.087 256C178.087 227.803 187.793 201.493 200.348 179.243Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.ae45745b23f96c3aa746383ad00507c6.svg";
export { ForwardRef as ReactComponent };